import CronosMainnet25_1 from './cronos-mainnet-25-1';
import CryptoOrgChainMainnet_1 from './crypto-org-chain-mainnet-1';

const chainList = [CryptoOrgChainMainnet_1, CronosMainnet25_1];

export default chainList;
